import React, { useEffect, useState } from "react";
import { Table, TableContainer, TableHead, TableRow, TableBody, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, Stack, Pagination} from "@mui/material";
import { StyledTableRow, StyledTableCell } from "../../atoms/tables/TableStyles";
import { SwitchContainerGTS } from "../../atoms/Controls/SwitchGTS";
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import DatePickerGST from "../../atoms/Controls/DatePickerGST";
import { useNavigate } from "react-router-dom";
import { IEntradaInventario, IEntSalInvSearch } from "../../interfaces/entrada-salida-interface";
import { IGlobalPoprop } from "../../interfaces/global-interface";
import { getServiceData } from "../../store/global-services";
import {formatDateFromStr, formatDateShort, UrlSiteBase } from '../../Global';
let { UrlBase } = UrlSiteBase();

const ListadoEntradasInventario = (globalProp?: IGlobalPoprop) => {
    const [entradas, setEntradas] = useState<IEntradaInventario[]>([]);
    const [idDistribuidora, setIdDistribuidoras] = useState<string>('0');
    const [distribuidoras, setDistribuidoras] = useState<any>([]);
    const [showDistribuidoras, setShowDistribuidoras] = useState(localStorage.getItem('idPerfil') === '1');
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const navigate = useNavigate();
    
    const getEntradasInventario = () => {
        let formData : IEntSalInvSearch = {
            idDistribuidora: idDistribuidora,
            page: page
        };
        if (selectedDate)
            formData.fecha = formatDateShort(selectedDate);
        getServiceData({ nombre: 'entrada-inventario', parametros: formData }).then((data) => {
            if (data.success) {
                setEntradas(data.entradas);
                setTotalPages(data.totalPages);
            }
        });
    };
    
    useEffect(() => {
        getServiceData({ nombre: 'distribuidoras', parametros: {estatus: 1}}).then(data => {
            if (data.success && data.distribuidoras)
                setDistribuidoras([...data.distribuidoras]);
        });
    }, []);

    useEffect(() => {
        getEntradasInventario();
    }, [idDistribuidora, page, selectedDate]);
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setIdDistribuidoras(value);
    }
    const handleEditar = (id: number) => {
        navigate(`${UrlBase}Entrada-Inventario/Editar/${id}`);
    };

    const handleAgregar = () => {
        if (idDistribuidora === '-1') {
            if (globalProp && globalProp.snackHandleOpen)
                globalProp.snackHandleOpen({open: true, message: "Debe seleccionar una distribuidora", color: "red"});
            return;
        }
        navigate(`${UrlBase}Entrada-Inventario/Agregar/${idDistribuidora}`);
    }
    const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    const handleDateChange = (newDate: any) => {
        setSelectedDate(newDate);
    };
    return (
        <>
            <div className="panel-actions floating flex-row">
                { !showDistribuidoras ? <></> :
                    <FormControl className="select-control">
                        <InputLabel id="perfil-label">Distribuidora</InputLabel>
                        <Select labelId="Distribuidora" id="distribuidora" name="idDistribuidora" value={idDistribuidora} label="Distribuidora" onChange={handleSelectChange}>
                            <MenuItem value={'-1'}>Sin distribuidora</MenuItem>
                                {distribuidoras?.map((distribuidora: any) => (
                                    <MenuItem key={"item-" + distribuidora?.id} value={distribuidora?.id}>{distribuidora?.nombre}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                }
                <DatePickerGST label="Fecha de entrada al inventario" value={selectedDate} onChange={handleDateChange} />
                <ButtonGST onClick={() =>handleAgregar()}>Agregar <AddIcon /></ButtonGST>
            </div>
            <TableContainer>
                <Table className="table-gts">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>Distribuidora</StyledTableCell>
                            <StyledTableCell>Usuario</StyledTableCell>
                            <StyledTableCell>Tipo Entrada</StyledTableCell>
                            <StyledTableCell>Estatus</StyledTableCell>
                            <StyledTableCell>Fecha</StyledTableCell>
                            <StyledTableCell>Acciones</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {entradas.map(entrada => (
                            <StyledTableRow key={entrada.id}>
                                <StyledTableCell>{entrada.id}</StyledTableCell>
                                <StyledTableCell>{entrada.distribuidora}</StyledTableCell>
                                <StyledTableCell>{entrada.usuario}</StyledTableCell>
                                <StyledTableCell>{entrada.tipo_entrada}</StyledTableCell>
                                <StyledTableCell><SwitchContainerGTS checked={entrada.estatus === 1}  /></StyledTableCell>
                                <StyledTableCell>{formatDateFromStr(entrada.fecha + "")}</StyledTableCell>
                                <StyledTableCell>
                                    <ButtonGST onClick={() => handleEditar(entrada.id)}><EditIcon /></ButtonGST>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            { totalPages > 1 ?
                <Stack spacing={2}>
                    <Pagination count={totalPages} page={page} onChange={handlePaginationChange} />
                </Stack> 
                : <></>
            }
        </>
    );
};

export default ListadoEntradasInventario;
